// extracted by mini-css-extract-plugin
var _1 = "n7jBkY";
var _2 = "Wx4ixC";
var _3 = "yTslQl";
var _4 = "Uvmt_u";
var _5 = "bcoUEK";
var _6 = "PlkoWy";
var _7 = "yzl07U";
var _8 = "tfOM29";
export { _1 as "ease-transition", _2 as "gradient-titanic-80", _3 as "linear-transition-05", _4 as "logo", _5 as "shadow-medium-titanic", _6 as "shadow-medium-titanic-hover", _7 as "shadow-titanic-1", _8 as "shadow-white" }
